module.exports = __webpack_public_path__ + "img/05.017372e6.png";